import { render, staticRenderFns } from "./GameHead.vue?vue&type=template&id=cfd8c036&scoped=true"
import script from "./GameHead.vue?vue&type=script&lang=js"
export * from "./GameHead.vue?vue&type=script&lang=js"
import style0 from "./GameHead.vue?vue&type=style&index=0&id=cfd8c036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd8c036",
  null
  
)

export default component.exports